import { Component } from '@angular/core';

@Component({
    selector: 'ssf-logout-screen',
    template: require('./logout-screen.component.html'),
    styles: [
        `
            :host {
                text-align: center;
            }
        `,
    ],
})

/**
 * Successful logout screen after clicking logout button. Can be used, when redirect is not demanded behaviour on logout.
 */
export class LogoutScreenComponent {
    public i18n = 'APP.LOGOUT-SCREEN.';
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/logout-screen/logout-screen.component.ts